export default __webpack_public_path__ + "static/media/sponsor-3.68eec4da.png";